export default __webpack_public_path__ + "static/media/stats.fadd41e5.png";